/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ImageViewer from './index';

import { actions as imageViewerActions } from '../../../redux/ui/imageViewer';
import { uiImageViewerSelector } from '../../../redux/ui/selectors';

const GlobalImageViewer = ({ config, closeImageViewer }) => (
  <ImageViewer config={config} onClose={closeImageViewer} />
);
GlobalImageViewer.propTypes = {
  config: PropTypes.shape({
    src: PropTypes.string,
    opened: PropTypes.bool,
  }),
  closeImageViewer: PropTypes.func,
};

const mapStateToProps = state => ({
  config: uiImageViewerSelector(state),
});

const mapDispatchToProps = {
  closeImageViewer: imageViewerActions.close,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalImageViewer);



// WEBPACK FOOTER //
// ./src/components/common/ImageViewer/GlobalImageViewer.jsx